/* eslint-disable no-new-func */
import { TradingFormula } from 'global/Securities/types/store/formula';

const generateInvestmentBalance = (
  configFormula: TradingFormula,
  price: number,
  lot: number,
  multiplier = 0,
  dayTradeLeverage = 0,
) => {
  const { formula, day_trade } = configFormula;

  const LOT = lot;
  const PRICE = price;
  const DAY_TRADE_LEVERAGE = dayTradeLeverage;

  const totalInvestment = new Function(
    'LOT',
    'PRICE',
    `return ${formula.buy_amount_invested};`,
  )(LOT, PRICE);

  const PORTION_DEDUCT_TO_TB = day_trade.portion_deduct_to_tb;
  const STOCK_MULTIPLIER = multiplier;

  const dayTradeUnrealized = new Function(
    'LOT',
    'PRICE',
    'PORTION_DEDUCT_TO_TB',
    'STOCK_MULTIPLIER',
    `return ${formula.day_trade_debt_unrealized};`,
  )(LOT, PRICE, PORTION_DEDUCT_TO_TB, STOCK_MULTIPLIER);

  const ORDER_UNREALIZED_DAY_TRADE_DEBT = dayTradeUnrealized;
  const investmentDayTrade = new Function(
    'ORDER_UNREALIZED_DAY_TRADE_DEBT',
    'DAY_TRADE_LEVERAGE',
    `const min = Math.min;
    return ${formula.day_trade_investment_day_trade};`,
  )(ORDER_UNREALIZED_DAY_TRADE_DEBT, DAY_TRADE_LEVERAGE);

  const INVESTMENT_DAY_TRADE = investmentDayTrade;
  const investmentTradingBalance = new Function(
    'LOT',
    'PRICE',
    'INVESTMENT_DAY_TRADE',
    `return ${formula.day_trade_investment_portion_tb};`,
  )(LOT, PRICE, INVESTMENT_DAY_TRADE);

  return {
    totalInvestment,
    investmentDayTrade,
    investmentTradingBalance,
  };
};

export default generateInvestmentBalance;
